import React, { useEffect, useState } from "react";
import { gql, useApolloClient, useMutation, useQuery } from "@apollo/client";
import { ProfessionalContentEntity } from "../../generated/graphql";
import { StreamsLayout } from "../../components/streams-layout/streams-layout";

const GET_LIBRARY_DATA = gql`
  query LibraryData {
    professionalContents {
      id
      name
      chapters {
        id
        chapter_name
        refdocs {
          id
          document_name
          reftype
          url
        }
      }
    }
  }
`;

interface LibraryData {
    professionalContents: ProfessionalContentEntity[];
}

export default function Library() {
    const { data, loading, error } = useQuery<LibraryData>(GET_LIBRARY_DATA);

    let streamsData: ProfessionalContentEntity[] = [];

    if(data && data.professionalContents) {
      streamsData = JSON.parse(JSON.stringify(data.professionalContents));
      for(const stream of streamsData) {
        for(const chapter of stream.chapters) {
          chapter.refdocs = chapter.refdocs.filter(refdoc => {
            return refdoc.reftype === "CUSTOM" || refdoc.reftype === "QUICKFLOW";
          })
        }
        stream.chapters = stream.chapters.filter(chapter => chapter.refdocs.length > 0);
      }
      streamsData = streamsData.filter(stream => stream.chapters.length > 0);
    }

    return (
        <div className="fixed inset-0 pt-16 bg-white flex flex-col flex-1">
            <StreamsLayout 
                streams={streamsData}
                refdocCount={{}}
                loading={loading}
                error={error?.message}
            />
        </div>
    );
}